import { capturePostHogEvent } from './posthogClient';

export function captureBeerIngestionEvent(eventName, properties) {
  try {
    capturePostHogEvent(eventName, properties);
  } catch {
    // Analytics must not break beer-ingestion actions.
  }
}

export function captureBeerIngestionCheckNow(breweryId, sourceId) {
  captureBeerIngestionEvent('engage-beer-ingestion-click-check-now', {
    breweryId,
    sourceId,
  });
}

export function captureBeerIngestionPause(breweryId, sourceId) {
  captureBeerIngestionEvent('engage-beer-ingestion-click-pause', {
    breweryId,
    sourceId,
  });
}

export function captureBeerIngestionResume(breweryId, sourceId) {
  captureBeerIngestionEvent('engage-beer-ingestion-click-resume', {
    breweryId,
    sourceId,
  });
}

export function captureBeerIngestionRecreateMonitor(breweryId, sourceId) {
  captureBeerIngestionEvent('engage-beer-ingestion-click-recreate-monitor', {
    breweryId,
    sourceId,
  });
}

export function captureBeerIngestionEnableMonitoring(payload) {
  captureBeerIngestionEvent('engage-beer-ingestion-click-enable-monitoring', payload);
}

export function captureBeerIngestionMonitoringFilter(monitoringFilter) {
  captureBeerIngestionEvent('engage-beer-ingestion-change-monitoring-filter', {
    monitoringFilter,
  });
}

export function captureBeerIngestionRunView(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-run-view', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionRunRetry(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-run-retry', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionSnapshotFilter(runId, breweryId, filter) {
  captureBeerIngestionEvent('engage-beer-ingestion-snapshot-filter', {
    runId,
    breweryId,
    filter,
  });
}

export function captureBeerIngestionSnapshotEmpty(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-snapshot-empty', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionSnapshotError(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-snapshot-error', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionComparisonFilter(runId, breweryId, filter) {
  captureBeerIngestionEvent('engage-beer-ingestion-comparison-filter', {
    runId,
    breweryId,
    filter,
  });
}

export function captureBeerIngestionReviewOpen(runId, breweryId, source) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-open', {
    runId,
    breweryId,
    source,
  });
}

export function captureBeerIngestionReviewFilter(runId, breweryId, filter) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-filter', {
    runId,
    breweryId,
    filter,
  });
}

export function captureBeerIngestionReviewApprove(runId, breweryId, candidateKey) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-approve', {
    runId,
    breweryId,
    candidateKey,
  });
}

export function captureBeerIngestionReviewReject(runId, breweryId, candidateKey) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-reject', {
    runId,
    breweryId,
    candidateKey,
  });
}

export function captureBeerIngestionReviewAcknowledge(runId, breweryId, candidateKey) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-acknowledge', {
    runId,
    breweryId,
    candidateKey,
  });
}

export function captureBeerIngestionReviewBulk(runId, breweryId, approvedCount, skippedCount) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-bulk-approve', {
    runId,
    breweryId,
    approvedCount,
    skippedCount,
  });
}

export function captureBeerIngestionReviewBulkReject(runId, breweryId, rejectedCount, skippedCount) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-bulk-reject', {
    runId,
    breweryId,
    rejectedCount,
    skippedCount,
  });
}

export function captureBeerIngestionReviewEdit(runId, breweryId, candidateKey, editing) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-edit', {
    runId,
    breweryId,
    candidateKey,
    editing,
  });
}

export function captureBeerIngestionReviewStyleTypeAssign(runId, breweryId, styleName, styleType) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-style-type-assign', {
    runId,
    breweryId,
    styleName,
    styleType,
  });
}

export function captureBeerIngestionReviewComplete(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-complete', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionReviewApply(
  runId,
  breweryId,
  addedCount,
  updatedCount,
  duplicatedCount,
  errorCount,
) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-apply', {
    runId,
    breweryId,
    addedCount,
    updatedCount,
    duplicatedCount,
    errorCount,
  });
}

export function captureBeerIngestionReviewEmpty(stateCode) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-empty', {
    stateCode,
  });
}

export function captureBeerIngestionReviewError(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-error', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionReviewNext(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-next', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionReviewPrevious(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-previous', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionReviewAutoAdvance(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-auto-advance', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionReviewBack(runId, breweryId) {
  captureBeerIngestionEvent('engage-beer-ingestion-review-back', {
    runId,
    breweryId,
  });
}

export function captureBeerIngestionFailuresView(stateCode, openCount) {
  captureBeerIngestionEvent('engage-beer-ingestion-failures-view', {
    stateCode,
    openCount,
  });
}

export function captureBeerIngestionFailuresRetry(itemId, category, breweryId, sourceId) {
  captureBeerIngestionEvent('engage-beer-ingestion-failures-retry', {
    itemId,
    category,
    breweryId,
    sourceId,
  });
}

export function captureBeerIngestionFailuresResolve(itemId) {
  captureBeerIngestionEvent('engage-beer-ingestion-failures-resolve', {
    itemId,
  });
}

export function captureBeerIngestionFailuresAutoPauseBannerView(autoPausedCount) {
  captureBeerIngestionEvent('engage-beer-ingestion-failures-auto-pause-banner-view', {
    autoPausedCount,
  });
}

export function captureBeerIngestionFailuresEmpty(stateCode) {
  captureBeerIngestionEvent('engage-beer-ingestion-failures-empty', {
    stateCode,
  });
}

export function captureBeerIngestionFailuresError(stateCode) {
  captureBeerIngestionEvent('engage-beer-ingestion-failures-error', {
    stateCode,
  });
}

export function captureBeerIngestionViewScoreboard(stateCode, trustedPercent, trustedMet) {
  captureBeerIngestionEvent('engage-beer-ingestion-view-scoreboard', {
    stateCode,
    trustedPercent,
    trustedMet,
  });
}

/** ITT-972: Increment 1a profile processing failure inbox / pulse. */
export function captureProfileProcessingFailuresView(openCount) {
  captureBeerIngestionEvent('engage-profile-processing-failures-view', {
    openCount,
  });
}

export function captureProfileProcessingFailuresRetry(itemId, category, breweryId, beerId) {
  captureBeerIngestionEvent('engage-profile-processing-failures-retry', {
    itemId,
    category,
    breweryId,
    beerId,
  });
}

export function captureProfileProcessingFailuresResolve(itemId) {
  captureBeerIngestionEvent('engage-profile-processing-failures-resolve', {
    itemId,
  });
}

export function captureProfileProcessingFailuresEmpty() {
  captureBeerIngestionEvent('engage-profile-processing-failures-empty', {});
}

export function captureProfileProcessingFailuresError() {
  captureBeerIngestionEvent('engage-profile-processing-failures-error', {});
}

export function captureProfileProcessingFailuresFilter(filterKind, filterValue) {
  captureBeerIngestionEvent('engage-profile-processing-failures-filter', {
    filterKind,
    filterValue,
  });
}

export function captureProfileProcessingPulseView(pulse) {
  captureBeerIngestionEvent('engage-profile-processing-pulse-view', {
    openFailures: pulse?.openFailures ?? 0,
    coveragePercent: pulse?.coveragePercent ?? 0,
    conflictCount: pulse?.conflictCount ?? 0,
    reportingStale: pulse?.reportingStale === true,
  });
}
